import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { Person } from '@app/data/model/person.model';
import { PrefilterData } from '@app/data/model/prefilter.model';

@Component({
  selector: 'app-result-card',
  templateUrl: './result-card.component.html',
  styleUrls: ['./result-card.component.scss']
})
export class ResultCardComponent {

  @Input() headerImage: string = '';

  @Output() onCardClick: EventEmitter<Person | PrefilterData> = new EventEmitter<Person | PrefilterData>();

  handleImageError(event: any) {
    console.log('Image not found', event);
    event.target.src = '/assets/icons/user_grey_light.svg'; // Set a placeholder image
    event.target.classList.replace("object-cover", "object-contain");

  }
}
